// extracted by css-extract-rspack-plugin
export default {"header":"Header-module__header__uNLur","content":"Header-module__content__YNr_X","heading":"Header-module__heading__zS0JU","subheading":"Header-module__subheading__wi_U2"};